var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_vm._t("default"),_c('v-spacer'),_c('v-btn',{on:{"click":_vm.cancelHandler}},[_vm._v("Отмена")]),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.submitDisabled},on:{"click":_vm.saveHandler}},[_vm._v(" "+_vm._s(_vm.submitBtnLabel)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }